// extracted by mini-css-extract-plugin
export default {"blogPosts":"articles_blogPosts__-tC2J"};